import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Button from '@telia-front/button';
import ImageZoom from '@telia-front/image-zoom';
import Video from '@telia-front/video';
import { LightboxContext } from '../lightbox-provider/lightbox-provider';
const LightboxTrigger = (props) => {
    const { open, id, triggerRef } = React.useContext(LightboxContext);
    const { children } = props;
    return (React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
            return child;
        }
        if (child.type === Anchor) {
            return React.cloneElement(child, {
                onClick: (event) => {
                    event.preventDefault();
                    open();
                },
                url: child.props.url || `#${id}`,
                elementRef: triggerRef,
            });
        }
        if (child.type === Button || child.type === ImageZoom) {
            return React.cloneElement(child, {
                onClick: (event) => {
                    event.preventDefault();
                    open();
                },
                url: child.props.url || `#${id}`,
                buttonRef: triggerRef,
            });
        }
        if (child.type === Video) {
            return React.cloneElement(child, {
                // it should open Lightbox and play video in there
                playing: false,
                onPlay: () => {
                    open();
                    if (child.props.onPlay) {
                        child.props.onPlay();
                    }
                },
                elementRef: triggerRef,
            });
        }
        return React.cloneElement(child, {
            onClick: (event) => {
                event.preventDefault();
                open();
            },
            url: child.props.url || `#${id}`,
            ref: triggerRef,
        });
    })));
};
export default LightboxTrigger;
